import styled from 'styled-components'

export const Input = styled.input`
  marginTop: 10px !important;

  display: block !important;
  width: 100% !important;
  height: 50px !important;
  border: solid 1px #bab4ce !important;

  padding: 15px 20px !important;
  border-radius: 3px !important;

  font-family: "SF Pro Display" !important;
  font-size: 16px !important;
  color: #172129 !important;

  ::placeholder {
    color: #979797 !important;
  }

  :hover, :focus {
    box-shadow: 0 16px 80px 0 rgba(93, 101, 207, 0.08), 0 8px 40px 0 rgba(79, 85, 217, 0.09) !important;
    border: solid 1px #2f358a !important;
    outline: none !important;
  }
`



// WEBPACK FOOTER //
// ./src/atoms/Input.tsx